import "../../pages/reports/gce-o.css";
import { ExamType } from "../../types/types";

interface SubjectData {
  code: string;
  name: string;
  student_count: string | number;
}

interface TTTSubjectsTableProps {
  registrationData: {
    exam_registration?: {
      subject_categories?: Record<string, SubjectData[]>;
    } | null;
  } | null;
  selectedExamTypes: ExamType[];
}

const TTTSubjectsTable: React.FC<TTTSubjectsTableProps> = ({
  registrationData,
  selectedExamTypes,
}) => {
  const shouldRenderTables = selectedExamTypes.some((et) => {
    return et.name.includes("TTT");
  });

  const tttCommon =
    registrationData?.exam_registration?.subject_categories?.TTTCOMMON;
  const tttCommercial =
    registrationData?.exam_registration?.subject_categories?.TTTCOMMERCIAL;
  const tttIndustrial =
    registrationData?.exam_registration?.subject_categories?.TTTINDUSTRIAL;

  if (!shouldRenderTables) return null;

  const leftSubjects = tttCommon ? tttCommon.slice(0, 6) : [];
  const rightSubjects = tttCommon ? tttCommon.slice(6) : [];
  const commonMaxRows = Math.max(leftSubjects.length, rightSubjects.length);

  const commercialSubjects = tttCommercial || [];
  const industrialSubjects = tttIndustrial || [];
  const maxRows = Math.max(
    commercialSubjects.length,
    industrialSubjects.length
  );

  return (
    <>
      {tttCommon && (
        <table className="gceo-subjects-table">
          <tbody>
            <tr>
              <th>COMMON SUBJECTS</th>
              <th># of Candidates</th>
              <th>COMMON SUBJECTS</th>
              <th># of Candidates</th>
            </tr>
            {Array.from({ length: commonMaxRows }, (_, index) => {
              const left = leftSubjects[index];
              const right = rightSubjects[index];
              return (
                <tr key={index}>
                  <td>{left ? `${left.code} ${left.name}` : ""}</td>
                  <td>{left ? left.student_count : ""}</td>
                  <td>{right ? `${right.code} ${right.name}` : ""}</td>
                  <td>{right ? right.student_count : ""}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}

      {(tttCommercial && tttCommercial.length > 0) ||
      (tttIndustrial && tttIndustrial.length > 0) ? (
        <table className="gceo-subjects-table" style={{ marginTop: "20px" }}>
          <tbody>
            <tr>
              <th colSpan={4}>PROFESSIONAL SUBJECTS</th>
            </tr>
            <tr>
              <th>COMMERCIAL</th>
              <th># of Candidates</th>
              <th>INDUSTRIAL</th>
              <th># of Candidates</th>
            </tr>
            {Array.from({ length: maxRows }, (_, index) => {
              const commercial = commercialSubjects[index];
              const industrial = industrialSubjects[index];
              return (
                <tr key={index}>
                  <td>{commercial ? commercial.student_count : ""}</td>
                  <td>
                    {commercial ? `${commercial.code} ${commercial.name}` : ""}
                  </td>
                  <td>
                    {industrial ? `${industrial.code} ${industrial.name}` : ""}
                  </td>
                  <td>{industrial ? industrial.student_count : ""}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : null}
    </>
  );
};

export default TTTSubjectsTable;
